import * as Types from '../graphql.generated';

export type Links_FragmentFragment = { __typename?: 'Links' } & Pick<
    Types.Links,
    'saveSearch' | 'createAlert'
>;

export const Links_FragmentFragmentDoc = `
    fragment LINKS_FRAGMENT on Links {
  saveSearch
  createAlert
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {};
}
export type Sdk = ReturnType<typeof getSdk>;
